import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiMapPin, FiClock, FiPhone, FiMail, FiUsers, FiAward, FiInfo } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import { FaPhoneAlt } from "react-icons/fa";

class Contact extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='ติดต่อเรา' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor1/IMG_7829.webp")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '50vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8 col-md-10 col-12">
                                <h1 className="hero-title" style={{
                                    color: 'white',
                                    fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                                    fontWeight: 'bold',
                                    marginBottom: '1rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
                                    lineHeight: '1.2'
                                }}>
                                    ติดต่อเรา
                                </h1>
                                <p className="hero-subtitle" style={{
                                    color: 'white',
                                    fontSize: 'clamp(1rem, 3vw, 1.2rem)',
                                    opacity: 0.9,
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
                                    lineHeight: '1.6',
                                    margin: 0
                                }}>
                                    ติดต่อสอบถามเราได้ทุกช่องทาง เรายินดีพร้อมให้บริการ
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Information Section */}
                <div className="contact-info-section ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12 mb-4">
                                <div className="contact-card" style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: 'clamp(1.5rem, 4vw, 2.5rem)',
                                    borderRadius: '20px',
                                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                    height: '100%',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid transparent'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                                    e.currentTarget.style.borderColor = '#F45354';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                                    e.currentTarget.style.borderColor = 'transparent';
                                }}>
                                    <div className="contact-icon" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 'clamp(60px, 8vw, 70px)',
                                        height: 'clamp(60px, 8vw, 70px)',
                                        backgroundColor: '#F45354',
                                        borderRadius: '50%',
                                        marginBottom: '1.5rem'
                                    }}>
                                        <FiMapPin style={{ color: 'white', fontSize: 'clamp(1.5rem, 3vw, 1.8rem)' }} />
                                    </div>
                                    <h4 style={{
                                        fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        ที่อยู่
                                    </h4>
                                    <div>
                                        <p style={{ 
                                            marginBottom: '1rem', 
                                            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                            lineHeight: '1.6'
                                        }}>
                                            <strong>อาคารพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่า</strong><br />
                                            ถนนอุทัยรามฤทธิ์ ตำบลในเมือง<br />
                                            อำเภอเมือง จังหวัดยโสธร 35000
                                        </p>
                                        <p style={{ 
                                            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                            lineHeight: '1.6'
                                        }}>
                                            <strong>สถานที่ติดต่อประสานงานทั่วไป</strong><br />
                                            กองการศึกษา เทศบาลเมืองยโสธร<br />
                                            เลขที่ 1 ถนนประชาสัมพันธ์<br />
                                            ตำบลในเมือง อำเภอเมืองยโสธร<br />
                                            จังหวัดยโสธร 35000
                                        </p>
                                        
                                        {/* Google Maps Button */}
                                        <div style={{ marginTop: '1.5rem' }}>
                                            <a 
                                                href="https://maps.app.goo.gl/diAsGuSCPDTMLqbj9" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    backgroundColor: '#F45354',
                                                    color: 'white',
                                                    padding: '0.75rem 1.5rem',
                                                    borderRadius: '25px',
                                                    textDecoration: 'none',
                                                    fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                                                    fontWeight: 'bold',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 4px 15px rgba(244, 83, 84, 0.3)',
                                                    border: '2px solid #F45354'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'translateY(-2px)';
                                                    e.target.style.boxShadow = '0 6px 20px rgba(244, 83, 84, 0.4)';
                                                    e.target.style.backgroundColor = '#e63946';
                                                    e.target.style.borderColor = '#e63946';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'translateY(0)';
                                                    e.target.style.boxShadow = '0 4px 15px rgba(244, 83, 84, 0.3)';
                                                    e.target.style.backgroundColor = '#F45354';
                                                    e.target.style.borderColor = '#F45354';
                                                }}
                                            >
                                                <FiMapPin style={{ 
                                                    marginRight: '0.5rem', 
                                                    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)' 
                                                }} />
                                                เปิดใน Google Maps
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12 mb-4">
                                <div className="contact-card" style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: 'clamp(1.5rem, 4vw, 2.5rem)',
                                    borderRadius: '20px',
                                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                    height: '100%',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid transparent'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                                    e.currentTarget.style.borderColor = '#F45354';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                                    e.currentTarget.style.borderColor = 'transparent';
                                }}>
                                    <div className="contact-icon" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 'clamp(60px, 8vw, 70px)',
                                        height: 'clamp(60px, 8vw, 70px)',
                                        backgroundColor: '#F45354',
                                        borderRadius: '50%',
                                        marginBottom: '1.5rem'
                                    }}>
                                        <FiPhone style={{ color: 'white', fontSize: 'clamp(1.5rem, 3vw, 1.8rem)' }} />
                                    </div>
                                    <h4 style={{
                                        fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        ติดต่อ
                                    </h4>
                                    <div>
                                        <p style={{
                                            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                            fontWeight: 'bold',
                                            color: '#F45354',
                                            marginBottom: '0.5rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexWrap: 'wrap'
                                        }}>
                                            <FaPhoneAlt style={{ marginRight: '0.5rem', flexShrink: 0 }} />
                                            โทรศัพท์ 045 712252
                                        </p>
                                        <p style={{ 
                                            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
                                            marginTop: '1rem',
                                            lineHeight: '1.6'
                                        }}>
                                            ติดต่อสอบถามข้อมูลเพิ่มเติม<br />
                                            จองเข้าชมเป็นหมู่คณะ<br />
                                            และบริการต่างๆ
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-12 col-12 mb-4">
                                <div className="contact-card" style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: 'clamp(1.5rem, 4vw, 2.5rem)',
                                    borderRadius: '20px',
                                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                    height: '100%',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid transparent'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                                    e.currentTarget.style.borderColor = '#F45354';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                                    e.currentTarget.style.borderColor = 'transparent';
                                }}>
                                    <div className="contact-icon" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 'clamp(60px, 8vw, 70px)',
                                        height: 'clamp(60px, 8vw, 70px)',
                                        backgroundColor: '#F45354',
                                        borderRadius: '50%',
                                        marginBottom: '1.5rem'
                                    }}>
                                        <FiClock style={{ color: 'white', fontSize: 'clamp(1.5rem, 3vw, 1.8rem)' }} />
                                    </div>
                                    <h4 style={{
                                        fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        วันและเวลาเปิดทำการ
                                    </h4>
                                    <div style={{ color: '#666', lineHeight: '1.6' }}>
                                        <div style={{
                                            backgroundColor: 'white',
                                            padding: 'clamp(0.75rem, 2vw, 1rem)',
                                            borderRadius: '10px',
                                            marginBottom: '1rem'
                                        }}>
                                            <p style={{ 
                                                margin: 0, 
                                                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                                lineHeight: '1.6'
                                            }}>
                                                <strong>วันอังคาร - วันศุกร์</strong><br />
                                                ตั้งแต่เวลา 9.00 – 16.00 น.
                                            </p>
                                        </div>
                                        <div style={{
                                            backgroundColor: 'white',
                                            padding: 'clamp(0.75rem, 2vw, 1rem)',
                                            borderRadius: '10px',
                                            marginBottom: '1rem'
                                        }}>
                                            <p style={{ 
                                                margin: 0, 
                                                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                                lineHeight: '1.6'
                                            }}>
                                                <strong>วันเสาร์ - วันอาทิตย์</strong><br />
                                                ตั้งแต่เวลา 9.30 – 16.30 น.
                                            </p>
                                        </div>
                                        <div style={{
                                            backgroundColor: '#F45354',
                                            color: 'white',
                                            padding: 'clamp(0.75rem, 2vw, 1rem)',
                                            borderRadius: '10px',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)'
                                        }}>
                                            หยุดวันจันทร์
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Additional Information Section */}
                <div className="additional-info-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="info-content" style={{
                                    backgroundColor: 'white',
                                    padding: 'clamp(2rem, 5vw, 3rem)',
                                    borderRadius: '20px',
                                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)'
                                }}>
                                    <h2 style={{
                                        fontSize: 'clamp(2rem, 5vw, 2.5rem)',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '2rem',
                                        textAlign: 'center'
                                    }}>
                                        ข้อมูลเพิ่มเติม
                                    </h2>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 mb-4">
                                            <div className="info-item" style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                marginBottom: '2rem',
                                                flexWrap: 'wrap'
                                            }}>
                                                <div className="info-icon" style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: 'clamp(45px, 6vw, 50px)',
                                                    height: 'clamp(45px, 6vw, 50px)',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginRight: '1rem',
                                                    flexShrink: 0,
                                                    marginBottom: '0.5rem'
                                                }}>
                                                    <FiUsers style={{ color: 'white', fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }} />
                                                </div>
                                                <div className="info-content" style={{ flex: 1, minWidth: '200px' }}>
                                                    <h4 style={{
                                                        fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
                                                        fontWeight: 'bold',
                                                        color: '#242424',
                                                        marginBottom: '0.5rem'
                                                    }}>
                                                        การเข้าชมเป็นหมู่คณะ
                                                    </h4>
                                                    <p style={{
                                                        color: '#666',
                                                        lineHeight: '1.6',
                                                        margin: 0,
                                                        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)'
                                                    }}>
                                                        สำหรับโรงเรียน สถาบันการศึกษา และหน่วยงานต่างๆ<br />
                                                        กรุณาติดต่อล่วงหน้าเพื่อจัดเตรียมวิทยากรและกิจกรรม
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 mb-4">
                                            <div className="info-item" style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                marginBottom: '2rem',
                                                flexWrap: 'wrap'
                                            }}>
                                                <div className="info-icon" style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: 'clamp(45px, 6vw, 50px)',
                                                    height: 'clamp(45px, 6vw, 50px)',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginRight: '1rem',
                                                    flexShrink: 0,
                                                    marginBottom: '0.5rem'
                                                }}>
                                                    <FiAward style={{ color: 'white', fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }} />
                                                </div>
                                                <div className="info-content" style={{ flex: 1, minWidth: '200px' }}>
                                                    <h4 style={{
                                                        fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
                                                        fontWeight: 'bold',
                                                        color: '#242424',
                                                        marginBottom: '0.5rem'
                                                    }}>
                                                        กิจกรรมพิเศษ
                                                    </h4>
                                                    <p style={{
                                                        color: '#666',
                                                        lineHeight: '1.6',
                                                        margin: 0,
                                                        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)'
                                                    }}>
                                                        จัดกิจกรรมพิเศษตามเทศกาลและโอกาสสำคัญ<br />
                                                        ติดตามข่าวสารได้ที่หน้าเว็บไซต์และโซเชียลมีเดีย
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                <Footer />
            </React.Fragment>
        )
    }
}

export default Contact;